import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";

const statuses = {
  Complete: "text-green-700 bg-green-50 ring-green-600/20",
  "In progress": "text-gray-600 bg-gray-50 ring-gray-500/10",
  Archived: "text-yellow-800 bg-yellow-50 ring-yellow-600/20",
};
const projects = [
  {
    id: 1,
    name: "WON",
    href: "#",
    status: "Complete",
    createdBy: "Leslie Alexander",
    dueDate: "02-11-2024",
    dueDateTime: "02-11-2024",
  },
  {
    id: 2,
    name: "Interested ",
    href: "#",
    status: "In progress",
    createdBy: "Leslie Alexander",
    dueDate: "02-11-2024",
    dueDateTime: "02-11-2024",
  },
  {
    id: 3,
    name: "Initial Contact ",
    href: "#",
    status: "In progress",
    createdBy: "Courtney Henry",
    dueDate: "02-11-2024",
    dueDateTime: "02-11-2024",
  },
  {
    id: 4,
    name: "Proposal sent ",
    href: "#",
    status: "In progress",
    createdBy: "Leonard Krasner",
    dueDate: "02-11-2024",
    dueDateTime: "02-11-2024",
  },
  {
    id: 5,
    name: "Visit to the center ",
    href: "#",
    status: "In progress",
    createdBy: "Courtney Henry",
    dueDate: "02-11-2024",
    dueDateTime: "02-11-2024",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export const BadgesSimple = () => {
  return (
    <ul role="list" className="divide-y divide-gray-100">
      {projects.map((project) => (
        <li
          key={project.id}
          className="flex items-center justify-between  py-5 pr-80"
        >
          <div className="min-w-0">
            <div className="flex items-start gap-x-3">
              <p className="text-sm font-semibold leading-6 text-gray-900">
                {project.name}
              </p>
            </div>
          </div>
          <div className="flex flex-none items-center gap-x-4">
            <p className="whitespace-nowrap">
              <time dateTime={project.dueDateTime}>{project.dueDate}</time>
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
};
